<template>
   <div class="input-help" v-html="apiText"></div>
</template>

<script>
import { Docs } from '../../utils/docs';

export default {
  name: 'ApiDescription.vue',
  props: {
    api: { type: String },
    description: { type: String }
  },
  computed: {
    apiText () {
      if (this.api) {
        return Docs.getDescription(this.api);
      } else {
        return this.description;
      }
    }
  }
};
</script>
